import React from 'react';
import { useRouter } from 'next/router';

import * as ST from './styled';

const cities = [
    {
        word: 'Б',
        city:[
            {
                'text': 'Барнаул',
                'link': 'barnaul',
            },
            {
                'text': 'Брянск',
                'link': 'bryansk',
            },
            {
                'text': 'Березники',
                'link': 'ber',
            },
        ],
    },
    {
        word: 'В',
        city:[
            {
                'text': 'Волгоград',
                'link': 'volgograd',
            },
            {
                'text': 'Волжский',
                'link': 'vlz',
            },
            {
                'text': 'Воронеж',
                'link': 'voronezh',
            },
        ],
    },
    {
        word: 'Д',
        city:[
            {
                'text': 'Дзержинск',
                'link': 'dzr',
            },
        ],
    },
    {
        word: 'Е',
        city:[
            {
                'text': 'Екатеринбург',
                'link': 'ekat',
            },
        ],
    },
    {
        word: 'И',
        city:[
            {
                'text': 'Ижевск',
                'link': 'izhevsk',
            },
            {
                'text': 'Иркутск',
                'link': 'irkutsk',
            },
        ],
    },
    {
        word: 'Й',
        city:[
            {
                'text': 'Йошкар-Ола',
                'link': 'yola',
            },
        ],
    },
    {
        word: 'К',
        city:[
            {
                'text': 'Казань',
                'link': 'kazan',
            },
            {
                'text': 'Киров',
                'link': 'kirov',
            },
            {
                'text': 'Красноярск',
                'link': 'krsk',
            },
            {
                'text': 'Курган',
                'link': 'kurgan',
            },
            {
                'text': 'Курск',
                'link': 'kursk',
            },
        ],
    },
    {
        word: 'Л',
        city:[
            {
                'text': 'Липецк',
                'link': 'lipetsk',
            },
        ],
    },
    {
        word: 'М',
        city:[
            {
                'text': 'Магнитогорск',
                'link': 'mgn',
            },
        ],
    },
    {
        word: 'Н',
        city:[
            {
                'text': 'Набережные Челны',
                'link': 'chelny',
            },
            {
                'text': 'Нижнекамск',
                'link': 'nk',
            },
            {
                'text': 'Нижний Новгород',
                'link': 'nn',
            },
            {
                'text': 'Новосибирск',
                'link': 'nsk',
            },
        ],
    },
    {
        word: 'О',
        city:[
            {
                'text': 'Омск',
                'link': 'omsk',
            },
            {
                'text': 'Оренбург',
                'link': 'oren',
            },
        ],
    },
    {
        word: 'П',
        city:[
            {
                'text': 'Пенза',
                'link': 'penza',
            },
            {
                'text': 'Пермь',
                'link': 'perm',
            },
        ],
    },
    {
        word: 'Р',
        city:[
            {
                'text': 'Ростов-на-Дону',
                'link': 'rostov',
            },
            {
                'text': 'Рязань',
                'link': 'ryazan',
            },
        ],
    },
    {
        word: 'С',
        city:[
            {
                'text': 'Самара',
                'link': 'samara',
            },
            {
                'text': 'Санкт-Петербург',
                'link': 'interzet',
            },
            {
                'text': 'Саратов',
                'link': 'saratov',
            },
            {
                'text': 'Сызрань',
                'link': 'syzran',
            },
        ],
    },
    {
        word: 'Т',
        city:[
            {
                'text': 'Тверь',
                'link': 'tver',
            },
            {
                'text': 'Томск',
                'link': 'tomsk',
            },
            {
                'text': 'Тула',
                'link': 'tula',
            },
            {
                'text': 'Тюмень',
                'link': 'tmn',
            },
        ],
    },
    {
        word: 'У',
        city:[
            {
                'text': 'Ульяновск',
                'link': 'ulsk',
            },
            {
                'text': 'Уфа',
                'link': 'ufa',
            },
        ],
    },
    {
        word: 'Ч',
        city:[
            {
                'text': 'Чебоксары',
                'link': 'cheb',
            },
            {
                'text': 'Челябинск',
                'link': 'chel',
            },
        ],
    },
    {
        word: 'Э',
        city:[
            {
                'text': 'Энгельс',
                'link': 'engels',
            },
        ],
    },
    {
        word: 'Я',
        city:[
            {
                'text': 'Ярославль',
                'link': 'yar',
            },
        ],
    },
];
interface IAllCity{
    closePopup: ()=> void,
    url: string,
}

const AllCity = ({ closePopup, url }:IAllCity) =>{
    const { query } = useRouter();

    return (
        <ST.Popup>
            <ST.PopupWrapper>
                <ST.PopupContent>
                    <ST.PopupClose onClick={closePopup}/>
                    <ST.City>
                        <ST.Title>
                            Выберите интересующий вас город
                        </ST.Title>
                        <ST.Line/>
                        <ST.FavoriteCity>
                            <ST.Link href={url ? `https://interzet.dom.ru/${url}` : `https://interzet.dom.ru/${query?.url ? query.url : ''}`}>Санкт-Петербург</ST.Link>
                            <ST.Link href={url ? `https://ekat.dom.ru/${url}` : `https://ekat.dom.ru/${query?.url ? query.url : ''}`}>Екатеринбург</ST.Link>
                            <ST.Link href={url ? `https://perm.dom.ru/${url}` : `https://perm.dom.ru/${query?.url ? query.url : ''}`}>Пермь</ST.Link>
                        </ST.FavoriteCity>
                        <ST.Line/>
                            <ST.CityWrapper>
                                {cities.map((item, index) => (
                                    <ST.CityBlock key={index}>
                                    <ST.CityMainLetter>{item.word}</ST.CityMainLetter>
                                    {item.city.map((city, index) => (
                                        <ST.CityContainer key={index}>
                                            <ST.LinkCity href={url ? `https://${city.link}.dom.ru/${url}` : `https://${city.link}.dom.ru/${query?.url ? query.url : ''}`}>{city.text}</ST.LinkCity>
                                        </ST.CityContainer>
                                    ))}
                                    </ST.CityBlock>
                                ))}
                            </ST.CityWrapper>
                    </ST.City>
                </ST.PopupContent>
            </ST.PopupWrapper>
        </ST.Popup>
    );
  };

export default AllCity;
